'use client'

import { useTranslations } from 'next-intl'

export function InvestorsPageContent() {
  const t = useTranslations('company')

  return (
    <section className="page">
      <header className="jobs-hero">
        <p className="hero-kicker">
          <i />
          <span>{t('ir.kicker')}</span>
          <i />
        </p>
        <h1>{t('ir.title')}</h1>
        <div className="ir-copy">
          <p>{t('ir.paragraph1')}</p>
          <p>{t('ir.paragraph2')}</p>
          <p>{t('ir.paragraph3')}</p>
        </div>
        <div className="ir-actions">
          <a className="cta-md" href="mailto:team@digen.ai">
            {t('ir.contact')}
          </a>
        </div>
      </header>
    </section>
  )
}
